import React from 'react';
import { Avatar, IconButton, Paper } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import { lighterGray } from 'utils/color-styles';
import type { Employee } from 'containers/CommunityPage/EmployeeSearch/UserMultiSelect';

export interface UserSelectedProps {
  user: Employee;
  removeMember: (userId: string) => void;
}

export const UserSelected = ({ user, removeMember }: UserSelectedProps) => {
  const name = `${user.fullName?.first || ''} ${user.fullName?.last || ''}`;
  return (
    <Paper
      elevation={0}
      style={{
        display: 'flex',
        alignItems: 'center',
        background: lighterGray,
        padding: '6px 10px',
        gap: 8,
        fontSize: 13,
      }}
    >
      {!!user.mainPicture && (
        <Avatar
          alt={name}
          src={user.mainPicture}
          style={{
            width: 36,
            height: 36,
            marginRight: 5,
            marginLeft: 5,
          }}
        />
      )}
      <span>
        {name} <span style={{ color: '#676767' }}>{user.organizationDepartment}</span>
      </span>

      <IconButton
        style={{ marginLeft: 'auto' }}
        aria-label={`Remove ${name} from selection`}
        onClick={(): void => removeMember(user.id)}
      >
        <ClearIcon />
      </IconButton>
    </Paper>
  );
};
